import { executeDsl, type DslExecuteResponse } from '../../services/DslService';
import type { DslTag } from './types';

export type TagExecutor = (expression: string) => Promise<DslExecuteResponse>;

export type TagExecResult =
  | { kind: 'ok'; response: DslExecuteResponse }
  | { kind: 'error'; message: string };

const formatRejection = (reason: unknown): string => {
  if (reason instanceof Error) return reason.message;
  if (typeof reason === 'string') return reason;
  try {
    return JSON.stringify(reason);
  } catch {
    return 'Unknown execution error';
  }
};

export const runDslTags = async (
  tags: DslTag[],
  executor: TagExecutor = executeDsl,
): Promise<Map<string, TagExecResult>> => {
  const results = new Map<string, TagExecResult>();
  if (tags.length === 0) return results;

  const settlements = await Promise.allSettled(
    tags.map((tag) => executor(tag.dsl)),
  );

  tags.forEach((tag, idx) => {
    const settlement = settlements[idx];
    if (settlement.status === 'fulfilled') {
      results.set(tag.id, { kind: 'ok', response: settlement.value });
    } else {
      results.set(tag.id, {
        kind: 'error',
        message: formatRejection(settlement.reason),
      });
    }
  });

  return results;
};
